'/create-folder/:parentId';

import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postTransferItemsBetweenPrivateAndPublicProjectBank = async ({
  itemIdsToTransfer,
  projectId,
  targetParentFolderId,
  sourceProjectBankPrivacy,
  targetProjectBankPrivacy,
  transferMethod,
}) => {
  const apiPath = `project-bank/${projectId}/transfer-items-between-private-and-public`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      itemIdsToTransfer,
      targetParentFolderId,
      sourceProjectBankPrivacy,
      targetProjectBankPrivacy,
      transferMethod,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
